import { render, staticRenderFns } from "./changerole.vue?vue&type=template&id=61332e2d&scoped=true"
import script from "./changerole.vue?vue&type=script&lang=js"
export * from "./changerole.vue?vue&type=script&lang=js"
import style0 from "./changerole.vue?vue&type=style&index=0&id=61332e2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61332e2d",
  null
  
)

export default component.exports